import ApiClient from 'api-client/ApiClient'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import ActionsSet from 'core/actions/ActionsSet'
import ListAction from 'core/actions/ListAction'
import UpdateAction from 'core/actions/UpdateAction'
import DeleteAction from 'core/actions/DeleteAction'
import CustomAction from 'core/actions/CustomAction'
import CreateAction from 'core/actions/CreateAction'
import store from 'app/store'
import { cacheActions } from 'core/caching/cacheReducers'
import moment from 'moment'

const { dispatch } = store
const { nova } = ApiClient.getInstance()

const getCurrentNovaFormattedTimestamp = () => {
  return moment()
    .utc()
    .format()
}

let lastRefreshTime = null

export const migrationActions = ActionsSet.make<DataKeys.VmMigrations>({
  uniqueIdentifier: 'id',
  entityName: entityNamesByKey.VmMigrations,
  cacheKey: DataKeys.VmMigrations,
})

export const listMigrations = migrationActions.add(
  new ListAction<DataKeys.VmMigrations>(async () => {
    const newTimestamp = getCurrentNovaFormattedTimestamp()
    lastRefreshTime = newTimestamp
    return nova.getMigrations()
  }),
)

export const getMigrationsSince = migrationActions.add(
  new CustomAction<DataKeys.VmMigrations>(
    'getMigrationsSince',
    async () => {
      if (!lastRefreshTime) {
        return []
      }
      const migrations = await nova.getMigrationsSince(lastRefreshTime)
      const newTimestamp = getCurrentNovaFormattedTimestamp()
      lastRefreshTime = newTimestamp
      return migrations
    },
    (result: any[], {}) => {
      dispatch(
        cacheActions.upsertAll({
          uniqueIdentifier: 'id',
          cacheKey: DataKeys.VmMigrations,
          items: result,
        }),
      )
    },
  ),
)
